//#region src/web/sdk/loadScript.ts
var e = /* @__PURE__ */ new Map();
function t(t) {
	let n = e.get(t);
	if (n) return n;
	let r = new Promise((n, r) => {
		let i = document.createElement("script");
		i.src = t, i.async = !0, i.defer = !0, i.onload = () => n(), i.onerror = () => {
			e.delete(t), r(/* @__PURE__ */ Error(`Failed to load script: ${t}`));
		}, document.head.appendChild(i);
	});
	return e.set(t, r), r;
}
//#endregion
export { t as loadScript };
